"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        type: 'textfield',
        input: true,
        key: 'footer',
        label: 'Footer Label',
        tooltip: 'The footer text that appears below the signature area.',
        placeholder: 'Footer Label',
        weight: 10,
    },
    {
        type: 'textfield',
        input: true,
        key: 'width',
        label: 'Width',
        tooltip: 'The width of the signature area.',
        placeholder: 'Width',
        customConditional: (context) => {
            var _a, _b, _c;
            const isPdf = ((_b = (_a = context.options) === null || _a === void 0 ? void 0 : _a.editForm) === null || _b === void 0 ? void 0 : _b.display) === 'pdf';
            return isPdf ? !((_c = context.data) === null || _c === void 0 ? void 0 : _c.keepOverlayRatio) : true;
        },
        weight: 50,
    },
    {
        type: 'textfield',
        input: true,
        key: 'height',
        label: 'Height',
        tooltip: 'The height of the signature area.',
        placeholder: 'Height',
        customConditional: (context) => {
            var _a, _b, _c;
            const isPdf = ((_b = (_a = context.options) === null || _a === void 0 ? void 0 : _a.editForm) === null || _b === void 0 ? void 0 : _b.display) === 'pdf';
            return isPdf ? !((_c = context.data) === null || _c === void 0 ? void 0 : _c.keepOverlayRatio) : true;
        },
        weight: 51,
    },
    {
        weight: 52,
        type: 'checkbox',
        label: 'Keep Overlay Aspect Ratio',
        tooltip: 'If checked, the field will have the same aspect ratio as its preview.',
        key: 'keepOverlayRatio',
        input: true,
    },
    {
        type: 'textfield',
        input: true,
        key: 'backgroundColor',
        label: 'Background Color',
        tooltip: 'The background color of the signature area.',
        placeholder: 'Background Color',
        weight: 52,
    },
    {
        type: 'textfield',
        input: true,
        key: 'penColor',
        label: 'Pen Color',
        tooltip: 'The ink color for the signature area.',
        placeholder: 'Pen Color',
        weight: 53,
    },
    {
        key: 'placeholder',
        ignore: true,
    },
    {
        key: 'autofocus',
        ignore: true,
    },
];
